import TeamStore from "../store";
import { action } from "satcheljs/lib/legacy";

export let updateTeamName = action("updateTeamName")(
    /**
     * Updates the team name of the current team
     */
    function updateTeamName(teamName: string) {
        TeamStore().team.name = teamName;
    });